// controller
import useGetData from "../../../hook/getData";
import { GetWishList } from "../../../services/panel/wishList/wishList";
import { Link } from "react-router";
import Heart from "../../../components/heart/heart";

const WishList = () => {
    const { data: list } = useGetData(["wishList"], GetWishList);
    return (
        <>
            <div className="card card-body shadow border-1 rounded rounded-4">
                <div className="rounded box-site rounded-4 d-flex justify-content-between align-items-center py-3 mb-0">
                    <span>علاقه مندی ها</span>
                </div>
                <div className="row gy-3 mt-4">
                    {list?.map((comment: any, index: number) => (
                        <div className="col-md-4">
                            <Link to={`/items/detail/${comment?.product?.slug}`} className="text-decoration-none">
                                <div className="card card-body border-0 rounded rounded-4 shadow">
                                    <div className="row align-items-center">
                                        <div className="col-4">
                                            <Link to={`/items/detail/${comment?.product?.slug}`} className="text-decoration-none">
                                                <img style={{ width: '100px', height: '90px', objectFit: 'contain' }} src={`https://admin.ariyasteelrad.ir/uploads/files/products/images/${comment?.product?.primary_image}`} alt="product" />
                                            </Link>
                                        </div>
                                        <div className="col-8">
                                            <div className="d-flex align-items-center justify-content-between mt-4 pb-0 mb-0">
                                                <p className="card-text text-black font-medium me-4">
                                                    {comment?.product?.name}
                                                </p>
                                            </div>
                                            <div className="position-absolute top-0 end-0 p-3">
                                                <Heart id={comment?.product?.id} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Link>
                        </div>
                    ))}

                </div>
            </div>
        </>
    )
}
export default WishList;